import { getPageData, prepareEventData, pushEvent } from './datalayer';
import { identify } from './customer-io';

(($) => {
  $(() => {
    const $contactForm = $('form#contact_form');

    if ($contactForm.length) {
      const $firstName = $contactForm.find('input[name="contact[first_name]"]');
      const $lastName = $contactForm.find('input[name="contact[last_name]"]');
      const $email = $contactForm.find('input[name="contact[email]"]');
      const $optIn = $contactForm.find('input[name="contact[opt_in]"]');

      const eventLocation = prepareEventData(getPageData('page-name'));

      $contactForm.on('submit', (e) => {
        const submitEvent = {
          event: 'action',
          attributes: {
            eventDetail: 'contact us',
            eventLocation,
          },
        };

        pushEvent(submitEvent);

        if ($optIn.length && $optIn.is(':checked')) {
          const optInEvent = {
            event: 'email subscription',
            attributes: {
              eventDetail: 'email opt in',
              eventLocation,
            },
          };

          pushEvent(optInEvent);

          const identity = {
            id: $email.val(),
            first_name: $firstName.val(),
            last_name: $lastName.val(),
            email: $email.val(),
            optin_src: $optIn.val(),
          };

          identify(identity);
        }
      });
    }
  });
})(jQuery);
